import { useRef, useEffect, useState } from 'react';
import { formatDate, getLastDate } from '../../../../lib/utils';
import { ReactComponent as CalendarSearchSvg } from '../../../../assets/svg/calendar-search.svg';
import CreateDialog from './createDialog';
import BodyLogBook from './logBook';
import request from '../../../../lib/request';
import PageTitle from '../../../../components/dialog/title';

const BodyProgress = () => {
  const createDialogRef = useRef(null);

  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [logs, setLogs] = useState([]);
  const [currentFile, setCurrentFile] = useState(null);
  const [source, setSource] = useState('');
  const [dataRange, setDataRange] = useState('30');

  useEffect(() => {
    const today = formatDate(new Date());
    const lastDate = formatDate(getLastDate(dataRange));

    getBodyLog(lastDate, today);
  }, [dataRange]);

  const getBodyLog = async (startDate, endDate) => {
    try {
      const { result } = await request.get(
        `/log/body?startDate=${startDate}&endDate=${endDate}`
      );

      if (result) {
        setLogs(result);
      }
    } catch (err) {
      console.log(err.response.data.error);
    }
  };

  const openCreateDialog = () => {
    if (createDialogRef.current) {
      createDialogRef.current.showModal();
      setIsCreateDialogOpen(true);
    }
  };

  const closeCreateDialog = () => {
    if (createDialogRef.current) {
      createDialogRef.current.close();
      setIsCreateDialogOpen(false);
    }
  };

  const refresh = async () => {
    const today = formatDate(new Date());
    const lastDate = formatDate(getLastDate(dataRange));

    await getBodyLog(lastDate, today);
  };

  const handleSelectRange = (e) => {
    setDataRange(e.target.value);
  };

  return (
    <div>
      <div className='flex justify-end items-center mb-4'>
        <select
          onChange={handleSelectRange}
          className='rounded-full px-2 py-1 bg-tertiary  text-white'
        >
          <option value='30'>Last 30 days</option>
          <option value='90'>Last 90 days</option>
          <option value='half'>Last 6 months</option>
          <option value='year'>Last 12 months</option>
        </select>
        <CreateDialog
          dialogRef={createDialogRef}
          closeDialog={closeCreateDialog}
          isDialogOpen={isCreateDialogOpen}
          currentFile={currentFile}
          source={source}
          setCurrentFile={setCurrentFile}
          setSource={setSource}
          refresh={refresh}
          firstLog={logs[0]}
        />
      </div>
      {logs.length > 0 && (
        <BodyLogBook
          logs={logs}
          refresh={refresh}
          openCreateDialog={openCreateDialog}
        />
      )}
      {logs.length === 0 && (
        <div className='flex flex-col justify-center items-center mt-4'>
          <div className='flex flex-col justify-center items-center py-12'>
            <div className='w-20 h-20 opacity-10'>
              <CalendarSearchSvg
                className='w-full h-full'
                fill='white'
              />
            </div>
            <p className='opacity-20 text-center text-white'>No logs</p>
          </div>
          <div>
            <button
              className='flex justify-center items-center text-white border px-3 py-2 rounded-full'
              onClick={openCreateDialog}
            >
              + Add your body log
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BodyProgress;
